import '../styles/main.scss'
import React from 'react'
import { createRoot } from 'react-dom/client'
import Fancybox from "./utils/fancybox";
import Accordion from './components/accordion'
import BasicModal from './components/basicModal'
import Slider from './components/slider'
import Base from './components/base'

import AOS from 'aos'
import 'aos/dist/aos.css'

document.addEventListener('DOMContentLoaded', () => {
    Fancybox();
    AOS.init();

    /*
    Base
     */

    const base = document.querySelector('.base');
    if (base) {
        createRoot(base).render(<Base items="Just a demo content for base React component. In case I forget how React works :D"/>);
    }

    /*
        Slider
     */
    const sliderEl = document.querySelector('.slider')

    if (sliderEl && window.sliderData) {
        createRoot(sliderEl).render(
          <Slider items={window.sliderData} />
        )
    }

    /*
    * Accordion
    * */
    const accordion = document.querySelector('.accordion');
    if (accordion) {
        createRoot(accordion).render(<Accordion items={repeaterData}/>);
    }

    const tabs = document.querySelector('.repeater-tabs');
    if (tabs) {
        createRoot(tabs).render(<VerticalTabs items={repeaterData}/>);
    }

    /*
    Modal
     */

    const modal = document.querySelector('.modal');
    if (modal) {
        createRoot(modal).render(<BasicModal items={modalData}/>);
    }



});